import React from 'react';
import { BrowserRouter } from 'react-router-v6';
import ChatBotContainer from 'hooks/chat-bot-container';

import Router from './react-router-v6/Router';
import { LoadingProvider } from 'hooks/use-loading';

function App() {
  return (
    <LoadingProvider>
      <BrowserRouter basename='/app'>
        <ChatBotContainer>
          <Router />
        </ChatBotContainer>
      </BrowserRouter>
    </LoadingProvider>
  );
}

export default App;
